// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_image'],
      sections: [addPanel.sections.getSections().image.imageStyleSection],
    };
  },
};
